import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import {FormattedMessage} from 'react-intl';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {clearSession} from '../../../common/Session';
import {commonOperations} from './../../../reducks/common';
import withRouter from '../withRouter';
import appConfig from '@/config';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  dialogcontext: {
    color: 'black',
    whiteSpace: 'pre-line',
  },
});

class CustomDialog extends React.Component {
  state = {
    runFlg: false,
    action: null,
    cancelFlg: false,
    cancelAction: null,
  };

  handleClose = (event) => {
    this.setState({runFlg: false});
    this.props.doCloseDialog();
  };

  handleRun = (event) => {
    this.setState({
      runFlg: true,
      cancelFlg: false,
      action: this.props.dialogInfo.action});
    this.props.doCloseDialog();
  };

  handleCancel = (event) => {
    this.setState({
      runFlg: false,
      cancelFlg: true,
      cancelAction: this.props.dialogInfo.cancelAction,
    });
    this.props.doCloseDialog();
  };

  handleError = (event) => {
    this.setState({runFlg: true, action: this.toRoot});
    this.props.doCloseDialog();
  };

  handleExited = (event) => {
    // ダイアログを表示した状態で、ブラウザバックなどの対処
    if (this.props.location.pathname !== this.props.dialogInfo.address) {
      this.props.doCloseDialog();
      return;
    }

    // OKボタン押下時、ボタン押下時の処理が設定されていれば実行
    if (this.state.runFlg && this.state.action) {
      this.state.action();
    }

    // キャンセルボタン押下時、ボタン押下時の処理が設定されていれば実行
    if (this.state.cancelFlg && this.state.cancelAction) {
      this.state.cancelAction();
    }
  };

  toRoot = () => {
    // セッションストレージのクリア
    clearSession();

    // ドメインルートへ遷移
    window.location.href = appConfig.BACK_TO_ROOT || '/';
  };

  render() {
    const {dialogInfo, classes, location} = this.props;
    const messages = [];

    return (
      <div>
        <Dialog
          open={dialogInfo.open && (location.pathname === dialogInfo.address)}
          TransitionProps={{onExited: this.handleExited}}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.handleClose(event);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          sx={{zIndex: '1501'}}
        >
          {dialogInfo.title &&
            <DialogTitle id="responsive-dialog-title"><FormattedMessage id={dialogInfo.title}/></DialogTitle>
          }
          <DialogContent>
            <DialogContentText className={classes.dialogcontext}>
              {Array.isArray(dialogInfo.context) &&
                dialogInfo.context.forEach((context) => {
                  let index = 1;
                  if (context.text) {
                    messages.push(context.text);
                  } else {
                    messages.push(
                        <React.Fragment key={'responsive-dialog-' + index++}>
                          <FormattedMessage
                            id={context.id}
                            values={context.values}
                          />
                          <br/>
                        </React.Fragment>);
                  }
                })
              }
              {messages.length > 0 && messages }
            </DialogContentText>
          </DialogContent>
          {(dialogInfo.type === 'ok') &&
          <DialogActions>
            <Button onClick={this.handleRun} color="primary">
              OK
            </Button>
          </DialogActions>
          }
          {(dialogInfo.type === 'okcancel') &&
          <DialogActions>
            <Button onClick={this.handleRun} color="primary">
              OK
            </Button>
            <Button onClick={this.handleCancel} color="primary">
              キャンセル
            </Button>
          </DialogActions>
          }
          {(dialogInfo.type === 'close') &&
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              OK
            </Button>
          </DialogActions>
          }
          {(dialogInfo.type === 'error') &&
          <DialogActions>
            <Button onClick={this.handleError} color="primary">
              OK
            </Button>
          </DialogActions>
          }
        </Dialog>
      </div>
    );
  }
}

CustomDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogInfo: PropTypes.object,
  doCloseDialog: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  location: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dialogInfo: state.common.dialogInfo,
});

const mapDispatchToProps = {
  doCloseDialog: commonOperations.closeDialog,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(CustomDialog)),
);
